// Règle métier OmniHub (2026-05-13) : un installateur est identifié par
// son ENTREPRISE dans toutes les listes, affichages, sélecteurs et
// références. Le champ `nom` du modèle est le nom du CONTACT — uniquement
// pour les coordonnées internes, jamais comme identifiant.
//
// Fallback : si `entreprise` est vide (legacy ou installateur "interne"
// personne physique), on retombe sur `nom` pour ne pas casser l'affichage.
// Pour les cas legacy, l'admin renseignera l'entreprise via la fiche.

export function getInstallateurDisplayName(inst) {
  if (!inst) return "—";
  const ent = (inst.entreprise || inst.raison_sociale || "").trim();
  if (ent) return ent;
  const nom = (inst.nom || "").trim();
  return nom || "—";
}

// Variante pour les snapshots dénormalisés sur les dossiers, où on a
// installateur_nom (string) sans accès à l'objet complet.
export function displayInstallateurNomSnapshot(snapshot) {
  return (snapshot || "").trim() || "—";
}

// Helper pour préparer le payload à l'écriture sur un dossier — choisit
// l'entreprise en priorité pour stocker la valeur "identifiante".
export function installateurSnapshotValue(inst) {
  return getInstallateurDisplayName(inst);
}
